import { Loader2 } from 'lucide-react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullPage?: boolean;
}

const sizeMap = { sm: 16, md: 24, lg: 40 };

export function LoadingSpinner({
  size = 'md',
  fullPage = false,
}: LoadingSpinnerProps) {
  const spinner = (
    <Loader2
      className="animate-spin text-primary"
      size={sizeMap[size]}
    />
  );
  if (fullPage) {
    return (
      <div className="flex items-center justify-center min-h-[50dvh]">
        {spinner}
      </div>
    );
  }
  return spinner;
}
